import { render } from "./ReleaseWantToBuy.vue?vue&type=template&id=2c5ed927&scoped=true&ts=true&lang=pug"
import script from "./ReleaseWantToBuy.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReleaseWantToBuy.vue?vue&type=script&lang=ts&setup=true"

import "./ReleaseWantToBuy.vue?vue&type=style&index=0&id=2c5ed927&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5ed927"]])

export default __exports__